import React, { Component } from 'react'
import {Table,TableBody,TableRow,Prompt,Response,TableHeading,RadioButton,TableContainer,CheckBox,TextInput} from '../../styles/form.js'
import {Header,Container, ContainerVertical,Alert,Text,SubmitButton} from '../../styles/style.js'
import FormHelp from './FormHelp.js';
import { FormInfo, ScoredForms} from './FormInfo.js'
import {AQ10}  from './FormStructure/AQ10.js';
import {AUDIT} from './FormStructure/AUDIT.js'
import {AQ50} from './FormStructure/AQ50.js'
import {ASRS1} from './FormStructure/ASRS1.js'
import {ASRS5} from './FormStructure/ASRS5.js'
import {ASRS} from './FormStructure/ASRS.js'
import {BPD} from './FormStructure/BPD.js'
import {DAST} from './FormStructure/DAST.js'
import {GAD} from './FormStructure/GAD.js';
import {MDQ} from './FormStructure/MDQ.js';
import {PHQ9} from './FormStructure/PHQ9.js';
import {PTSD} from './FormStructure/PTSD.js';
import {Wellness} from './FormStructure/Wellness.js';
import {WHO5} from './FormStructure/WHO5.js';
import {Family} from './FormStructure/Family.js';
import {Trauma} from './FormStructure/Trauma.js';
import {Development} from './FormStructure/Development.js';
import {Environmental} from './FormStructure/Environmental.js';
import {Medication} from './FormStructure/Medication.js';
import {PRIME} from './FormStructure/PRIME.js';
import {ASRM} from './FormStructure/ASRM.js';
import {TAS20} from './FormStructure/TAS-20.js';
import {PTQ} from './FormStructure/PTQ.js'
import {CATQ} from './FormStructure/CATQ.js';
import {PMDD} from './FormStructure/PMDD.js'
export default class Form extends Component {
    constructor(props){
        super(props);
        this.formHelp = new FormHelp();
        this.selectForm();
        this.formHelp.setComponent(this);
        this.formHelp.setName(this.selectedForm.Metadata.Name);
        this.formHelp.setColumnLength(this.selectedForm.Metadata.maxColumn);
        this.state = this.formHelp.getList(this.selectedForm.Metadata.numRows);

        this.handleClick = this.formHelp.handleClick.bind(this);
    }

    selectForm(){
        switch (this.props.formName){
            case FormInfo.AQ10.name:
                this.selectedForm = AQ10;
                break;
            case FormInfo.AUDIT.name:
                this.selectedForm = AUDIT;
                break;
            case FormInfo.AQ50.name:
                this.selectedForm = AQ50;
                break;
            case FormInfo.ASRS1.name:
                this.selectedForm = ASRS1;
                break;
            case FormInfo.ASRS5.name:
                this.selectedForm = ASRS5;
                break;
            case FormInfo.ASRS.name:
                this.selectedForm = ASRS;
                break;
            case FormInfo.BPD.name:
                this.selectedForm = BPD;
                break;
            case FormInfo.DAST.name:
                this.selectedForm = DAST;
                break;
            case FormInfo.GAD.name:
                this.selectedForm = GAD;
                break;
            case FormInfo.MDQ.name:
                this.selectedForm = MDQ;
                break;
            case FormInfo.PHQ9.name:
                this.selectedForm = PHQ9;
                break;
            case FormInfo.PTSD.name:
                this.selectedForm = PTSD;
                break;
            case FormInfo.Wellness.name:
                this.selectedForm = Wellness;
                break;
            case FormInfo.WHO5.name:
                this.selectedForm = WHO5;
                break;
            case FormInfo.Family.name:
                this.selectedForm = Family;
                break;
            case FormInfo.Trauma.name:
                this.selectedForm = Trauma;
                break;
            case FormInfo.Development.name:
                this.selectedForm = Development;
                break;
            case FormInfo.Environmental.name:
                this.selectedForm = Environmental;
                break;
            case FormInfo.Medication.name:
                this.selectedForm = Medication;
                break;
            case FormInfo.Prime.name:
                this.selectedForm = PRIME;
                break;
            case FormInfo.ASRM.name:
                this.selectedForm = ASRM;
                break;
            case FormInfo.TAS20.name:
                this.selectedForm = TAS20;
                break;
            case FormInfo.PTQ.name:
                this.selectedForm = PTQ;
                break;
            case FormInfo.CATQ.name:
                this.selectedForm = CATQ;
                break;
            case FormInfo.PMDD.name:
                this.selectedForm = PMDD;
                break;
            default:
        }
    }

    onChange = e =>{
        if(e.target.type === 'checkbox'){
            if(this.state[e.target.name] === 'Yes'){
                this.setState({[e.target.name] : 'No'});
            }else{
                this.setState({[e.target.name] : 'Yes'});
            }
        }else{
            this.setState({[e.target.name] : e.target.value});
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.formHelp.handleClick);
        window.addEventListener('resize',this.resize);
        this.resize()
        window.scrollTo(0, 0);
        if(this.props.formData !== undefined){
            this.selectData(this.props.formData)
        }
    }

    componentWillUnmount(){
        this.formHelp.clearTime();
        document.removeEventListener('click', this.formHelp.handleClick);
        window.removeEventListener('resize',this.resize);
    }

    getData(){
        if(this.props.formName === FormInfo.Family.name){
            let map  = {}
            for(var i = 0;i < FormInfo.Family.numRows;i++){
                let list = [];
                if(this.state[FormInfo.Family.name + '_' + i + '_father'] === 'Yes'){
                    list.push('Father');
                }
    
                if(this.state[FormInfo.Family.name + '_' + i + '_mother'] === 'Yes'){
                    list.push('Mother');
                }
    
                if(this.state[FormInfo.Family.name + '_' + i + '_brother'] === 'Yes'){
                    list.push('Brother');
                }
                
                if(this.state[FormInfo.Family.name + '_' + i + '_sister'] === 'Yes'){
                    list.push('Sister');
                }
    
                if(this.state[FormInfo.Family.name + '_' + i + '_grandmother'] === 'Yes'){
                    list.push('Grandmother');
                }
                
                if(this.state[FormInfo.Family.name + '_' + i + '_grandfather'] === 'Yes'){
                    list.push('Grandfather');
                }
                
                if(this.state[FormInfo.Family.name + '_' + i + '_son'] === 'Yes'){
                    list.push('Son');
                }
                
                if(this.state[FormInfo.Family.name + '_' + i + '_daughter'] === 'Yes'){
                    list.push('Daughter');
                }
                
                if(this.state[FormInfo.Family.name + '_' + i + '_self'] === 'Yes'){
                    list.push('Self');
                }
                map[FormInfo.Family.name + '_' + i] = list;
            }
    
            return map;
        }else if(this.props.formName === FormInfo.Medication.name){
            let map = {[FormInfo.Medication.name + '_taken']:[],[FormInfo.Medication.name + '_side']:[],[FormInfo.Medication.name + '_helpful']:[]};
            for(let i = 0;i < FormInfo.Medication.numRows;i++){
                if(this.state[FormInfo.Medication.name + '_' + i + '_taken'] === 'Yes'){
                    map[FormInfo.Medication.name + '_taken'].push(i);
                }

                if(this.state[FormInfo.Medication.name + '_' + i + '_side'] === 'Yes'){
                    map[FormInfo.Medication.name + '_side'].push(i);
                }

                if(this.state[FormInfo.Medication.name + '_' + i + '_helpful'] === 'Yes'){
                    map[FormInfo.Medication.name + '_helpful'].push(i);
                }

                if(this.state[FormInfo.Medication.name + '_' + i + '_c'] !== ''){
                    map[FormInfo.Medication.name + '_' + i + '_c'] = this.state[FormInfo.Medication.name + '_' + i + '_c'];
                }
            }
            return map;
        }else{
            let list = {};
            let index = 0;
            for(let i = 0;i < this.selectedForm.Sections.length;i++){
                for(let j = 0;j < this.selectedForm.Sections[i].Questions.length;j++){
                    for(let k = 1;k < this.selectedForm.Sections[i].Headers.length;k++){
                        if(document.getElementById(this.props.formName + '_' + index + '_c')  !== null){
                            list[this.props.formName + '_' + index + '_c'] = document.getElementById(this.props.formName + '_' + index + '_c').value;
                        }
                        
                        if(document.getElementById(this.props.formName + '_' + index + '_' + k) !== null &&
                            document.getElementById(this.props.formName + '_' + index + '_' + k).checked){
                            list[this.props.formName + '_' + index] = this.selectedForm.Sections[i].Headers[k];
                        }

                        if(this.props.formName === FormInfo.Trauma.name){
                            if(this.state[FormInfo.Trauma.name + '_' + index + '_adult'] === 'Yes'){
                                list[this.props.formName + '_' + index + '_adult'] = 'Yes'
                            }

                            if(this.state[FormInfo.Trauma.name + '_' + index + '_child'] === 'Yes'){
                                list[this.props.formName + '_' + index + '_child'] = 'Yes'
                            }
                        }
                    }
                    index++;
                }
            }

            if(ScoredForms.includes(this.props.formName)){
                var score = 0;
                if(this.props.formName === FormInfo.ASRS.name){
                    var scorePartA = 0;
                    var scorePartB = 0;

                    for(let i = 0;i < FormInfo.ASRS.numRows;i++){

                        if(Number.isInteger(parseInt(this.state[FormInfo.ASRS.name + '_' + i],10))){
                            if(i < 9){
                                scorePartA += parseInt(this.state[FormInfo.ASRS.name + '_' + i],10);
                            }else{
                                scorePartB += parseInt(this.state[FormInfo.ASRS.name + '_' + i],10);
                            }   
                        }
                    }

                    score = Math.max(scorePartA,scorePartB)

                }else{
                    for(const key in this.state){
                        if(Number.isInteger(parseInt(this.state[key],10))){
                            score += parseInt(this.state[key],10);
                        }
                    }
                }
            }

            list['score'] = score;

            return list;
        }
    }

    getBody(){
        var body = []
        var index = 0;
        for(let i = 0;i < this.selectedForm.Sections.length;i++){
            var headers = [];
            for(let j = 0;j < this.selectedForm.Sections[i].Headers.length;j++){
                headers.push(
                    <TableHeading 
                        key={this.props.formName + '_' + i + '_header' + j}
                        dangerouslySetInnerHTML={{ __html: this.selectedForm.Sections[i].Headers[j]}}> 
                    </TableHeading>
                )
            }
            body.push(<TableRow key={this.props.formName + '_' + i + '_headers'}>{headers}</TableRow>)

            for(let j = 0;j < this.selectedForm.Sections[i].Questions.length;j++){
                var question = []
                question.push(
                    <Prompt 
                        className={(index % 2 === 0) ? 'even':'odd'}
                        id={this.props.formName + '_' + index + '_p'}
                        key={this.props.formName + '_' + index + '_p'}>
                        {this.selectedForm.Sections[i].Questions[j].Prompt}
                    </Prompt>
                )

                for(let k = 0;k < this.selectedForm.Sections[i].Questions[j].Responses.length;k++){
                    question.push(
                        <Response 
                            className={(index % 2 === 0) ? 'even':'odd'}
                            id={this.props.formName + '_' + index + '_r' + (k + 1)}
                            key={this.props.formName + '_' + index + '_r' + (k + 1)}>
                            {this.selectedForm.Sections[i].Questions[j].Responses[k].Type === 'radio' &&
                                <RadioButton
                                    type='radio'
                                    name={this.props.formName + '_' + index}
                                    id={this.props.formName + '_' + index + "_" + (k + 1)}
                                    key={this.props.formName + '_' + index + "_" + (k + 1)}
                                    onChange={this.onChange}
                                    value={this.selectedForm.Sections[i].Questions[j].Responses[k].Value}>
                                </RadioButton>
                            }

                            {this.selectedForm.Sections[i].Questions[j].Responses[k].Type === 'checkbox' &&
                                <CheckBox
                                    type='checkbox'
                                    name={this.props.formName + '_' + index + '_' + this.selectedForm.Sections[i].Questions[j].Responses[k].Value}
                                    id={this.props.formName + '_' + index + "_" + this.selectedForm.Sections[i].Questions[j].Responses[k].Value}
                                    key={this.props.formName + '_' + index + "_" + (k + 1)}
                                    onChange={this.onChange}
                                    value='Yes'>
                                </CheckBox>
                            }

                            {this.selectedForm.Sections[i].Questions[j].Responses[k].Type === 'text' &&
                                <TextInput
                                    name={this.props.formName + '_' + index + '_c'} 
                                    value={this.state[this.props.formName + '_' + index + '_c']} 
                                    id={this.props.formName + '_' + index + '_c'} 
                                    key={this.props.formName + '_' + index + "_" + (k + 1)}
                                    onChange={this.onChange} 
                                    maxLength='50'>                          
                                </TextInput>
                            }
                        </Response>
                    )
                }
                body.push(<TableRow key={this.props.formName + index + '_question'}>{question}</TableRow>)
                index++;
            }

        }

        return body;
    }

    getCollapsedBody = () =>{
        var body = []
        var index = 0;
        for(let i = 0;i < this.selectedForm.Sections.length;i++){
            body.push(
                <TableRow key={this.props.formName + '_' + i + '_header0'}>
                    <TableHeading 
                        colSpan={2}
                        dangerouslySetInnerHTML={{ __html:  this.selectedForm.Sections[i].Headers[0]}}></TableHeading>
                </TableRow>
            )
            for(let j = 0;j < this.selectedForm.Sections[i].Questions.length;j++){
                var question = []
                if(j !== 0){
                    body.push(
                        <TableRow key={this.props.formName + '_' + i + '_header' + j}>
                            <TableHeading colSpan={2}></TableHeading>
                        </TableRow>
                    )
                }
                body.push(
                    <TableRow key={this.props.formName + '_' + index + '_prow'}>
                        <Prompt 
                            className={(index % 2 === 0) ? 'even':'odd'}
                            id={this.props.formName + '_' + index + '_p'}
                            colSpan={2}
                            key={this.props.formName + '_' + index + '_p'}>
                            {this.selectedForm.Sections[i].Questions[j].Prompt}
                        </Prompt>
                    </TableRow>
                )

                for(let k = 0;k < this.selectedForm.Sections[i].Questions[j].Responses.length;k++){
                    body.push(
                        <TableRow key={this.props.formName + '_' + index + '_r' + k}>
                            <Prompt 
                                className={(index % 2 === 0) ? 'even':'odd'}
                                id={this.props.formName + '_' + index + '_p' + (k + 1)}
                                key={this.props.formName + '_' + index + '_p' + (k + 1)}>
                                {this.selectedForm.Sections[i].Headers[k+1]}
                            </Prompt>
                            <Response 
                                className={(index % 2 === 0) ? 'even':'odd'}
                                id={this.props.formName + '_' + index + '_r' + (k + 1)}
                                key={this.props.formName + '_' + index + '_r' + (k + 1)}>
                                {this.selectedForm.Sections[i].Questions[j].Responses[k].Type === 'radio' &&
                                    <RadioButton
                                        type='radio'
                                        name={this.props.formName + '_' + index}
                                        id={this.props.formName + '_' + index + "_" + (k + 1)}
                                        key={this.props.formName + '_' + index + "_" + (k + 1)}
                                        onChange={this.onChange}
                                        value={this.selectedForm.Sections[i].Questions[j].Responses[k].Value}>
                                    </RadioButton>
                                }

                                {this.selectedForm.Sections[i].Questions[j].Responses[k].Type === 'checkbox' &&
                                    <CheckBox
                                        type='checkbox'
                                        name={this.props.formName + '_' + index + '_' + this.selectedForm.Sections[i].Questions[j].Responses[k].Value}
                                        id={this.props.formName + '_' + index + "_" + this.selectedForm.Sections[i].Questions[j].Responses[k].Value}
                                        key={this.props.formName + '_' + index + "_" + (k + 1)}
                                        onChange={this.onChange}
                                        value='Yes'>
                                    </CheckBox>
                                }

                                {this.selectedForm.Sections[i].Questions[j].Responses[k].Type === 'text' &&
                                    <TextInput
                                        name={this.props.formName + '_' + index + '_c'} 
                                        value={this.state[this.props.formName + '_' + index + '_c']} 
                                        id={this.props.formName + '_' + index + '_c'}
                                        key={this.props.formName + '_' + index + "_" + (k + 1)} 
                                        onChange={this.onChange} 
                                        maxLength='50'>                          
                                    </TextInput>
                                }
                            </Response>
                        </TableRow>
                    )
                }
                body.push(<TableRow key={this.props.formName + '_' + index + '_question'}>{question}</TableRow>)
                index++;
            }

        }

        return body;
    }
    
    selectData = data =>{
        if(this.props.formName === FormInfo.Family.name){
            for (const [key, value] of Object.entries(data)) {
                for(var i = 0;i < value.length;i++){
                    document.getElementById(key + '_' + value[i].toLowerCase()).checked = true;
                }
            }
        }else if(this.props.formName === FormInfo.Medication.name){
            for (const [key, value] of Object.entries(data)) {
                if(key === FormInfo.Medication.name + '_side'){
                    for(let i = 0;i < value.length;i++){
                        document.getElementById(FormInfo.Medication.name + '_' + value[i] + '_side').checked = true;
                    }
                }else if(key === FormInfo.Medication.name + '_taken'){
                    for(let i = 0;i < value.length;i++){
                        document.getElementById(FormInfo.Medication.name + '_' + value[i] + '_taken').checked = true;
                    }
                }else if(key === FormInfo.Medication.name + '_helpful'){
                    for(let i = 0;i < value.length;i++){
                        document.getElementById(FormInfo.Medication.name + '_' + value[i] + '_helpful').checked = true;
                    }
                }else{
                    document.getElementById(key).value = value;
                }
            }
        }else{
            for (const [key, value] of Object.entries(data)) {
                if(key !== 'score' && key !== 'submitText' && key !== 'showCollapsed' && key !== 'showAlert'){
                    if(key.slice(-2) === '_c'){
                        document.getElementById(key).value = value;
                    }else if(document.getElementById(key) !== null && value === 'Yes'){
                        document.getElementById(key).checked = true;
                    }else{
                        if(this.props.formName === FormInfo.ASRM.name && !isNaN(parseInt(value, 10))){
                            var index = parseInt(value,10) + 1
                            document.getElementById(key + '_' + index).checked = true;
                        }else{
                            for(let i = 0;i < this.selectedForm.Sections.length;i++){
                                let index = this.selectedForm.Sections[i].Headers.indexOf(value);
                                if(index !== -1){
                                    document.getElementById(key + '_' + index).checked = true;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    resize = () =>{
        if(window.innerWidth <= 440 && this.state.showCollapsed !== true){
            let data = this.getData();
            this.setState({showCollapsed:true},()=>{
                setTimeout(()=>{
                    requestAnimationFrame(()=>{this.selectData(data)})
                })
            })
        }else if(window.innerWidth > 440 && this.state.showCollapsed !== false){
            let data = this.getData();
            this.setState({showCollapsed:false},()=>{
                setTimeout(()=>{
                    requestAnimationFrame(()=>{this.selectData(data)})
                })
            })
        }
    }


    render() {
        return (
            <div style={{'marginBottom':'10em'}}> 
                {this.props.formData !== undefined && this.props.formData.score !== undefined &&
                    <Text>Score: {this.props.formData.score}</Text>
                } 
                {this.state.showAlert &&
			        <Alert>
				        <Text>Error Submitting Form</Text>
				        <SubmitButton 
                            onClick={()=>{this.setState({showAlert:false})}}>
                            OK
                        </SubmitButton>
			        </Alert>
                }
                {this.props.formName === FormInfo.Prime.name && this.props.fullExam && this.state.show_header &&
                    <ContainerVertical>
                        <Header>Do you ever hear voices that aren't your own, or see people that aren't actually in the room?</Header>
                        <Container style={{width:'fit-content'}}>
                            <SubmitButton 
                                style={{marginRight:'1em'}}
                                name={FormInfo.Prime.name + '_yes'} 
                                onClick={this.formHelp.handleClick.bind(this)}>
                                Yes
                            </SubmitButton>
                            <SubmitButton 
                                name={FormInfo.Prime.name + '_no'} 
                                onClick={this.formHelp.handleClick.bind(this)}>
                                No
                            </SubmitButton>
                        </Container>
                    </ContainerVertical>
                }
                {((this.props.formName === FormInfo.Prime.name && (this.state.show_prime || !this.props.fullExam)) || this.props.formName !== FormInfo.Prime.name)  && 
                    <form onSubmit={this.formHelp.handleSubmit}>
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    {!this.state.showCollapsed && this.props.formName !== FormInfo.ASRM.name && this.getBody()}
                                    {(this.state.showCollapsed || this.props.formName === FormInfo.ASRM.name) && this.getCollapsedBody()}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {this.props.formData === undefined &&
                            <SubmitButton type='submit'>{this.state.submitText}</SubmitButton>
                        }
                    </form>
                }
            </div>
        )
    }
}